import { render, staticRenderFns } from "./eventlist.vue?vue&type=template&id=7686404c&"
import script from "./eventlist.vue?vue&type=script&lang=js&"
export * from "./eventlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports